import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {Row, Card, Form, Label, Input, CardTitle} from 'reactstrap';
import LoaderButton from '../../components/LoaderButton';
import {Colxx} from '../../components/common/CustomBootstrap';
import {Form as FinalForm, Field} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import {required} from "../../helpers/Validators";
import Api from '../../services/Api';
import ToolTip from "../../components/ToolTip";
import {NotificationManager} from "../../components/common/react-notifications";
import {setGoogleAuthStatus} from "../../redux/authUser/actions";
import copy from "copy-to-clipboard";
import {store} from "../../AppRenderer";

class Security extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      registered: false,
    };
  }

  componentDidMount() {
    this.sendOTT();
  }

  registerGoogleAuth = async (values) => {
    const {ott} = values;
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/googleAuth', null, {
        headers: {
          'X-INNODAX-AUTH-2FA': ott,
        },
      });
      this.setState({
        registered: true,
        data,
      });
    } catch (e) {
      return null;
    }
  };

  enableGoogleAuth = async (values) => {
    const {googleAuthToken} = values;
    try {
      await Api.invoke('PATCH', '/v2/admin-ui/googleAuth', {
        enabled: true,
        googleAuthToken,
      });
      await this.afterEnableGoogleAuth(googleAuthToken);
    } catch (e) {
      return null;
    }
  };

  afterEnableGoogleAuth = async googleAuthToken => {
    const {history, location} = this.props;
    try {
      await Api.passwordGrant({
        ...location.state.loginValues,
        googleAuthToken,
        scope: ["ALL"],
      });
      store.dispatch(setGoogleAuthStatus({
        registered: true,
        enabled: true,
      }));
      history.replace("/dashboard");
    } catch (e) {
      await Api.logOut();
      history.replace("/user/login");
    }
  };

  sendOTT = async () => {
    try {
      await Api.invoke('POST', '/v2/admin-ui/ott', {
        channel: 'ALL',
        type: 'REGISTER_GOOGLE_AUTH',
      });
    } catch (e) {}
  };

  render() {
    const {t} = this.props;
    const {registered, data} = this.state;
    return (
      <FinalForm
        onSubmit={!registered ? this.registerGoogleAuth : this.enableGoogleAuth}
        render={({handleSubmit, pristine, submitting, hasValidationErrors}) => (
          <Row className="h-100">
            <Colxx xxs="12" md="10" className="mx-auto my-auto">
              <Card className="auth-card">
                <div className="position-relative image-side ">
                  <p className="text-white h2">
                    {t('2FA Page')}
                  </p>
                </div>
                <div className="form-side">
                  <NavLink to={'/'} className="white">
                    <span className="logo-single"/>
                  </NavLink>
                  <CardTitle className="mb-2">
                    {registered ?
                      t('Copy the related verification code from google authenticator and enter it in the input below.') :
                      t('Please enter the verification code sent to your email or mobile number to generate google-authenticator secret key for you.')
                    }
                  </CardTitle>
                  {registered &&
                    <div className="my-4">
                      <img src={data.qrUrl} width={160} height={160}/>
                      <div className='d-flex flex-row align-items-center'>
                        <ToolTip id={1} text={t('copy')}>
                          <span
                            className='text-one text-primary'
                            onClick={() => {
                              copy(data.secret.base32);
                              NotificationManager.info(t('Secret key copied'), t('Message'));
                            }}
                          >
                            <i className='icon-File-Copy2 cursor-pointer'/>
                          </span>
                        </ToolTip>
                        <span className='font-weight-semibold text-info mx-1'>{data.secret.base32}</span>
                      </div>
                    </div>
                  }
                  <Form onSubmit={handleSubmit}>
                    {!registered ?
                      <Field name="ott" validate={required}>
                        {({input}) => (
                          <div>
                            <Label className="form-group has-float-label mb-4">{t('Verification code')}
                              <Input {...input} type="text"/>
                            </Label>
                          </div>
                        )}
                      </Field> :
                      <Field name="googleAuthToken" validate={required}>
                        {({input}) => (
                          <div>
                            <Label className="form-group has-float-label mb-4">{t('Verification code')}
                              <Input {...input} type="text"/>
                            </Label>
                          </div>
                        )}
                      </Field>
                    }
                    <div className="d-flex justify-content-between align-items-center mt-5">
                      <LoaderButton
                        color="primary"
                        size="lg"
                        loading={submitting}
                        disabled={submitting || pristine || hasValidationErrors}
                        onClick={handleSubmit}>
                        {t('Submit')}
                      </LoaderButton>
                    </div>
                  </Form>
                </div>
              </Card>
            </Colxx>
          </Row>
        )}
      />
    );
  }
}

export default withTranslation()(Security);
